export default __webpack_public_path__ + "static/media/eye.2af129ac.svg";